import script from "./LeaderboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeaderboardPage.vue?vue&type=script&setup=true&lang=ts"

import "./LeaderboardPage.vue?vue&type=style&index=0&id=55cfc261&lang=css"

const __exports__ = script;

export default __exports__